import { api } from '@/api'
import { BaseApi } from '@/api/BaseApi.ts'
import type { GroupData } from '@/api/Group/types.ts'
import type { FetchParams, Paginated, ParamType } from '@/api/types.ts'
import type {
  AlterPasswordData,
  CurrentUser,
  UserData,
  UserFormData,
} from '@/api/User/types.ts'

class Api extends BaseApi<UserFormData, Paginated<UserData>, UserFormData> {
  readonly baseUrl = '/users'

  async getSelf() {
    const url = `${this.baseUrl}/me`
    const { data } = await api.get<CurrentUser>(url, this.config)
    return data
  }

  async resetPassword(
    id: ParamType,
    payload: AlterPasswordData
  ): Promise<void> {
    const url = `${this.baseUrl}/${id}/password`
    const { data } = await api.patch<void>(url, payload, this.config)
    return data
  }

  async toggleUserState(id: ParamType): Promise<void> {
    const url = `${this.baseUrl}/${id}/enabled`
    const { data } = await api.patch<void>(url, {}, this.config)
    return data
  }

  async addUserToGroup(userId: ParamType, groupId: ParamType): Promise<void> {
    const url = `${this.baseUrl}/${userId}/groups/${groupId}`
    await api.put(url, {}, this.config)
  }

  async removeUserFromGroup(
    userId: ParamType,
    groupId: ParamType
  ): Promise<void> {
    const url = `${this.baseUrl}/${userId}/groups/${groupId}`
    await api.delete(url, this.config)
  }

  async fetchUserGroups(
    id: ParamType,
    params: FetchParams
  ): Promise<Paginated<GroupData>> {
    const URParams = new URLSearchParams(this.buildFetchParams(params))
    const url = `${this.baseUrl}/${id}/groups?${URParams.toString()}`
    const { data } = await api.get<Paginated<GroupData>>(url, this.config)
    return data
  }
}

const UserApi = new Api()

export default UserApi
